export const ENTITY_NAME = 'importFile_'
export const SET_TAB_PAGE = 'SET_TAB_PAGE'